import React from 'react';
import Docs from '@/components/Documents/docs/Docs';
import { withRouter, connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store'

@withRouter
class ApiDocs extends React.Component {
  constructor() {
    super();
    this.apiId = null;
  }

  componentWillMount() {
    const apiId = this.props.router.currentRoute.params.docs;
    // 加载数据

    if(apiId === this.apiId) {
      return;
    }
    dispatch.stabledocs.fetch({ apiId });
    this.apiId = apiId;
  }

  componentWillUpdate() {
    const apiId = this.props.router.currentRoute.params.docs;
    // 加载数据

    if(apiId === this.apiId) {
      return;
    }
    dispatch.stabledocs.CLEAN_API();
    dispatch.stabledocs.fetch({ apiId });
    this.apiId = apiId;
  }

  render() {
    const { api, inParamsTable } = this.props;
    return <Docs api={api} inParamsTable={inParamsTable} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const docs = state.stabledocs;
  return {
    api: docs.api,
    inParamsTable: docs.inParamsTable
  }
}

export default connect(mapStateToProps)(ApiDocs);
